import React from 'react'
import { TagPillEl } from './TagPill.styles'

interface TagPillProps {
	children: React.ReactNode
}

/** Solid-orange category pill used on itinerary event cards. */
const TagPill: React.FC<TagPillProps> = ({ children }) => <TagPillEl>{children}</TagPillEl>

export default TagPill
